import { Scribbles } from "@somethings-ui/core/assets";
import { Composer } from "@somethings-ui/web";
import {
  AI_CHAT_PROMPTS,
  formatPromptLabel,
  type AiChatPrompt,
} from "./ai-chat-prompts";

interface AiChatEmptyStateProps {
  teenName: string;
  onSelectPrompt: (prompt: AiChatPrompt, label: string) => void;
}

export function AiChatEmptyState({
  teenName,
  onSelectPrompt,
}: AiChatEmptyStateProps) {
  const name = teenName.trim().length > 0 ? teenName.trim() : "your mentee";

  return (
    <div className="flex flex-1 flex-col items-start justify-end gap-4 px-4 pb-4">
      <div className="flex flex-col items-start gap-3">
        <span className="flex size-14 items-center justify-center rounded-full border border-surfaces-z5 bg-white">
          <img
            src={Scribbles.orangeLoops}
            alt=""
            aria-hidden
            className="size-10 object-contain"
          />
        </span>
        <h2 className="font-heading text-header-5 text-text-primary">
          Ask about {name}
        </h2>
      </div>
      <div className="flex flex-col items-start gap-2">
        {AI_CHAT_PROMPTS.map((prompt) => {
          const label = formatPromptLabel(prompt.label, teenName);
          return (
            <Composer.SuggestionPill
              key={prompt.id}
              className="text-text-tertiary"
              onClick={() => onSelectPrompt(prompt, label)}
            >
              {label}
            </Composer.SuggestionPill>
          );
        })}
      </div>
    </div>
  );
}
